import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Login.css';
import { EyeSlashIcon, EyeIcon } from '../../components/icons/Icons';
import api from '../../utils/axiosConfig';
import { Button } from '../../components/buttons/Button';

const Login = () => {
  const [studentUid, setStudentUid] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Auto-fill saved credentials on mount
  useEffect(() => {
    const savedUid = localStorage.getItem('remember_studentUid');
    const savedPassword = localStorage.getItem('remember_password');
    if (savedUid && savedPassword) {
      setStudentUid(savedUid);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const response = await api.post('login', {
        student_uid: studentUid,
        password: password,
      });

      if(response.status === 200){
        // Always store token in sessionStorage
        sessionStorage.setItem('token', response.data.token);

        // Save or clear credentials
        if (rememberMe) {
          localStorage.setItem('remember_studentUid', studentUid);
          localStorage.setItem('remember_password', password);
        } else {
          localStorage.removeItem('remember_studentUid');
          localStorage.removeItem('remember_password');
        }
        setIsSubmitting(false);
        navigate('/dashboard');
    }
      
    } catch (err) {
      setIsSubmitting(false);
      if (err.response && err.response.status === 401) {
        setError('Your credentials are incorrect.');
      } else {
        console.log(err.response)
        setError(err.response.data.error);
      }
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="row login-wrapper shadow bg-white rounded overflow-hidden mx-auto">

        {/* Left Section */}
        <div className="col-md-8 d-none d-md-flex flex-column align-items-center justify-content-center p-4 bg-blue-dark text-white">
          <img src="/asset/img/logo/logo.png" alt="Logo" width="80" className="mb-3 rounded-circle" />
          <h4>Khwaja Yunus Ali University</h4>
          <p className="text-center mt-3 px-3">
            Welcome to the official students login portal. Please enter your credentials to continue.
          </p>
        </div>

        {/* Right Section */}
        <div className="col-12 col-md-4 p-4">
          <h3 className="mb-4 text-center">Sign In</h3>

          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label htmlFor="student_uid" className="form-label">Student ID</label>
              <input type="text" inputMode="numeric"  pattern="\d*" maxLength="17" className="form-control" name="student_uid" id="student_uid" placeholder="Enter your Student ID" value={studentUid}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/\D/g, '').slice(0, 17);
                  setStudentUid(numericValue);
                }}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">Password</label>
              <div className="input-group">
                <input type={showPassword ? 'text' : 'password'}  className="form-control" id="password" name="password" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)} />
                <span className="input-group-text" style={{ cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
                </span>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="form-check">
                <input className="form-check-input" type="checkbox"  id="rememberMe" checked={rememberMe}  onChange={(e) => setRememberMe(e.target.checked)}/>
                <label className="form-check-label" htmlFor="rememberMe">Remember me</label>
              </div>
              {/* <NavLink to="/forgot-password" className="text-decoration-none small">Forgot password?</NavLink> */}
            </div>

             <Button label="Sign In" disabled={isSubmitting}/>
          </form>

          <div className="mt-4 text-center">
            <NavLink to="/contact" className="btn btn-outline-secondary btn-sm rounded-pill">Important Contact</NavLink>
          </div>

          <div className="mt-3 text-muted text-center">Software Version: 1.1</div>
        </div>
      </div>
    </div>
  );
};

export default Login;
